import API from '@Services/apiAxios';

export const DOCUMENT_TYPE = 'shipment'; // Flexible configuration for changing it later in one place

export interface ExtractionResponse {
  message?: string;
  state?: string;
  [key: string]: any;
}

export const extractDocument = async (s3Key: string): Promise<ExtractionResponse> => {
  const response = await API.post<ExtractionResponse>('/speedboxbot/extract', {
    documentType: DOCUMENT_TYPE,
    s3Key,
  });
  return response.data;
};
